export default __webpack_public_path__ + "static/media/le_croise9.35c666a9.jpg";